import { render, staticRenderFns } from "./UserCreateChoiceModal.vue?vue&type=template&id=457f80f9&scoped=true"
import script from "./UserCreateChoiceModal.vue?vue&type=script&lang=js"
export * from "./UserCreateChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./UserCreateChoiceModal.vue?vue&type=style&index=0&id=457f80f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f80f9",
  null
  
)

export default component.exports